import React from "react";
import ApprovalStatus from "./Components/approvalStatus";
import ViewReceipt from "./ViewReceipt";
import { useState } from "react";
import { StampToDate } from "../../Utils/utils";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useMobileCheck from "../../Hooks/useMobileCheck";
import { getReceiptReimbursementEligibility } from "../../Utils/expenseReimbursement";

function Receipt({ openId, onDrag, id = "", date, createdAt, amount = 0, merchant, currency = "INR", categoryId, category = {}, status = "", description = "", attachments = [], approvers = [], violations = [], onReload = () => {}, onDelete, onAddToReimbursement }) {
	const [OpenId, setOpenId] = useState(openId);
	const { isMobile } = useMobileCheck();
	const { canDrag } = getReceiptReimbursementEligibility({ status, categoryId });
	const draggable = onDrag && canDrag;
	const isSelectionCard = Boolean(onDelete);
	const spendDate = StampToDate(date);
	const createdDate = StampToDate(createdAt);
	const merchantName = merchant || "-";
	const categoryName = category?.name || "Uncategorized";
	const descriptionText = description || "-";

	return (
		<>
			<div
				draggable={draggable}
				onDragEnd={() => onDrag()}
				onDragStart={() => onDrag({ id, date, createdAt, amount, merchant, currency, categoryId, category, status, description, attachments, approvers, violations })}
				onClick={() => {
					if (!isSelectionCard) setOpenId(id);
				}}
				className={`relative flex flex-col justify-between overflow-hidden border shadow-sm rounded-xl bg-canvas min-w-min group ${isSelectionCard ? "cursor-default" : "cursor-pointer hover:bg-light"}`}
			>
				{isSelectionCard ? (
					<div className="p-3 space-y-2">
						<div className="flex items-start justify-between gap-2">
							<div>
								<div className="text-[10px] uppercase tracking-wide text-secondary">Amount</div>
								<h3 className="leading-tight">
									{currency} {amount}
								</h3>
							</div>
							<div className="text-right shrink-0">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Created</div>
								<div className="text-label">{createdDate}</div>
							</div>
						</div>
						<div className="p-2 border rounded-lg bg-light/60 border-surface">
							<div className="flex items-start justify-between gap-2 text-xs">
								<span className="text-secondary">Spent On</span>
								<span className="font-medium text-dark">{spendDate}</span>
							</div>
							<div className="flex items-start justify-between gap-2 mt-1 text-xs">
								<span className="text-secondary">Merchant</span>
								<span className="font-medium text-dark break-words text-right">{merchantName}</span>
							</div>
							<div className="flex items-start justify-between gap-2 mt-1 text-xs">
								<span className="text-secondary">Category</span>
								<span className="font-medium text-dark break-words text-right">{categoryName}</span>
							</div>
						</div>
						<div className="flex justify-end pt-1 border-t border-surface">
							<button
								type="button"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(id);
								}}
								className="inline-flex items-center gap-1 px-2 py-1 text-[11px] font-medium rounded-md bg-danger text-dangerText ring-1 ring-dangerText/20 hover:bg-dangerText hover:text-canvas"
								aria-label={`Remove receipt RPT-${id} from reimbursement`}
							>
								<FiTrash2 size={11} /> Remove
							</button>
						</div>
					</div>
				) : (
					<div className="p-4 space-y-3">
						<div className="flex items-start justify-between gap-3">
							<div>
								<div className="text-[10px] uppercase tracking-wide text-secondary">Amount</div>
								<h2 className="leading-tight">
									{currency} {amount}
								</h2>
							</div>
							<div className="text-right shrink-0">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Created</div>
								<div className="text-label">{createdDate}</div>
							</div>
						</div>

						<div className="grid gap-2 p-3 border rounded-lg bg-light/60 border-surface grid-cols-1 sm:grid-cols-2">
							<div className="rounded-md bg-canvas/80 p-2">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Spent On</div>
								<div className="mt-0.5 text-xs font-medium text-dark">{spendDate}</div>
							</div>
							<div className="rounded-md bg-canvas/80 p-2">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Merchant</div>
								<div className="mt-0.5 text-xs font-medium text-dark break-words">{merchantName}</div>
							</div>
							<div className="rounded-md bg-canvas/80 p-2">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Category</div>
								<div className="mt-0.5 text-xs font-medium text-dark break-words">{categoryName}</div>
							</div>
							<div className="rounded-md bg-canvas/80 p-2 sm:col-span-2">
								<div className="text-[10px] uppercase tracking-wide text-secondary">Purpose</div>
								<div className="mt-0.5 text-xs font-medium text-dark break-words">{descriptionText}</div>
							</div>
						</div>

						<div className="flex flex-wrap justify-end items-center gap-1 pt-2 border-t border-surface">
							<button
								type="button"
								onClick={(e) => {
									e.stopPropagation();
									setOpenId(id);
								}}
								className="inline-flex items-center gap-1 px-2 py-1 text-[11px] font-medium rounded-md bg-surface text-dark ring-1 ring-muted hover:bg-muted"
								aria-label={`Edit receipt RPT-${id}`}
							>
								<FiEdit2 size={11} /> Edit
							</button>
						</div>
					</div>
				)}
				<ApprovalStatus draggable={draggable} showDragHint={draggable && !isMobile} status={status} id={id} categoryId={categoryId} description={description} amount={amount} date={date} merchant={merchant} attachments={attachments} violations={violations} onAddToReimbursement={onAddToReimbursement} />
			</div>
			<ViewReceipt onReload={onReload} receiptId={OpenId} onClose={() => setOpenId()} />
		</>
	);
}

export default Receipt;
